import React, { Fragment } from "react";
import { Row, Col, ListGroup, ListGroupItem, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import _ from "lodash";

const PublicationQuestions = ({ publicationQuestions }) => {
  const questions = Array.isArray(publicationQuestions) ? publicationQuestions : [];
  
  const renderAnswerField = (question, key) => {
    const id = `question${key + 1}`;
    const answerType = question.answerType?.value || question.answerType || question.answer_type || "text";
    
    let options = [];
    if (question.options) {
      if (Array.isArray(question.options)) {
        options = question.options;
      } else if (typeof question.options === "string" && question.options.length > 0) {
        try {
          options = JSON.parse(question.options);
          if (!Array.isArray(options)) {
            options = question.options.split(",").map(s => s.trim());
          }
        } catch {
          options = question.options.split(",").map(s => s.trim());
        }
      }
    }

    switch (answerType) {
      case "boolean":
        return (
          <div>
            <FormGroup check inline>
              <Label check>
                <Input type="radio" name={id} disabled /> Sí
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input type="radio" name={id} disabled /> No
              </Label>
            </FormGroup>
          </div>
        );
      case "number":
        return (
          <Input
            type="number"
            placeholder="Ingrese un número"
            name={id}
            id={id}
            disabled
          />
        );
      case "single_choice":
        return (
          <Input type="select" name={id} id={id} disabled>
            <option>Seleccione una opción</option>
            {options.map((opt, idx) => (
              <option key={idx} value={opt}>{opt}</option>
            ))}
          </Input>
        );
      case "multiple_choice":
        return (
          <Select
            isMulti
            name={id}
            inputId={id}
            options={options.map(opt => ({ value: opt, label: opt }))}
            isDisabled={true}
            placeholder="Seleccione una o más opciones"
            className="basic-multi-select"
            classNamePrefix="select"
            value={[]}
          />
        );
      case "text":
      default:
        return (
          <Input
            type="textarea"
            placeholder="Escriba su Respuesta"
            name={id}
            id={id}
            disabled
          />
        );
    }
  };

  return (
    <Fragment>
      {questions.length > 0 && (
        <Row>
          <Col md="12">
            <h3 className="h6 font-weight-bold">
              <i className="fas fa-question mr-2"></i>
              Preguntas de la Publicación
            </h3>
            <ListGroup flush>
              {_.map(questions, (question, key) => {
                const questionText = question.value || question.name || "";
                
                return (
                  <ListGroupItem key={key}>
                    <FormGroup>
                      <Label for={`question${key + 1}`} className="input_required">
                        Pregunta {key + 1}: {questionText}
                      </Label>
                      {renderAnswerField(question, key)}
                    </FormGroup>
                  </ListGroupItem>
                );
              })}
            </ListGroup>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default PublicationQuestions;
